import { createAsyncThunk } from '@reduxjs/toolkit';
import ax from 'services/apiService';
//exams
export const getExam = createAsyncThunk('get-exam', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Exam/getexamlist`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
//add-exam create_exam
export const addExam = createAsyncThunk('add-exam', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Exam/save_exam`, payload);

        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const createExam =createAsyncThunk('create-exam', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Exam/create_exam`, payload);

        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const deleteExam = createAsyncThunk('delete-exam', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.delete(`api/api/exam_management/remove-exam/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/examurl
export const guestLogin = createAsyncThunk('guest-login', async (payload: any, { rejectWithValue }) => {
    try {
        // const response = await ax.post(`api/api/exam_management/examurl`, payload);

        // console.log('Headers in Axios:', response.headers); // <-- should include x-real-data

        // const successMessage = response.data.successMessage;
        // const encodedData = response.headers['x-real-data'];

        // let realData = null;
        // if (encodedData) {
        //     const decodedStr = atob(encodedData);
        //     realData = JSON.parse(decodedStr);
        // }

        // return realData;
        const { data } = await ax.post(`api/guest-login`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/exams/1
export const getExamDetail = createAsyncThunk('get-exam-detail', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Exam/getexam/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
//submit Exam
export const submitExam = createAsyncThunk('guest-login-submit-exam', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`apis/api/Exam/SubmitExam`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const submitExam2 = createAsyncThunk('guest-login-submit2-exam', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/examsubmit_2`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/examresult
export const getIndividualResult = createAsyncThunk('get-individual-result', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Exam/candidate_exam_result`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

// result
// exam_management/examresult
export const getAllResult = createAsyncThunk('get-all-result', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Exam/exam_result_list`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/examresult
export const exportAllResult = createAsyncThunk('export-all-result', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/candidate_exam_results`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const removeExam = createAsyncThunk('remove-exam-result', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/remove_exam`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

// exam_management/exam_report_draft
export const draftExam = createAsyncThunk('draft-exam-result', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`apis/api/Exam/save_examanswer_draft`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/dept_question
export const getDeptQuestions = createAsyncThunk('dept-questions', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/dept_question`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

// exam_management/examemail_send/118
export const sendMailtoAll = createAsyncThunk('send-exam-mail', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/examemail_send`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/dashexam_list
export const dashboardExamList = createAsyncThunk('dashboard-exam-listl', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Account/dashExamList/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

// exam_management/generate_auto_question
export const autoGenerateQuestion = createAsyncThunk('generate_auto_question', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/generate_auto_question`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// exam_management/exam_start
export const getExamStarted = createAsyncThunk('get_exam_started', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/exam_start`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// new_generate_auto_question
export const generateAutoQuestion = createAsyncThunk('generate-new-auto-question', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/exam_management/new_generate_auto_question`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// Account/associate_candidate_list
export const AssoCandidateList = createAsyncThunk('associate-candidate-exam', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Account/associate_candidate_list`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
//Exam/get_exam_quesion
export const getExamQuesDetail = createAsyncThunk('get_exam_quesion', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`apis/api/Exam/get_exam_quesion`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// Exam/exam_candidate_save

export const saveAssCandidList = createAsyncThunk('save-ass-candidate-list', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Exam/exam_candidate_save`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getExamDetails = createAsyncThunk('get-exam-details', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Exam/get_examdetails`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const sendMailToCandidate = createAsyncThunk('send-mail-cand', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Mail/send_mail_candexam`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getExamDetailTotalMark = createAsyncThunk('get-exam-detailmark', async (payload: { id: any; tenentId: any }, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Exam/getexam/${payload.id}/${payload.tenentId}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});